/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * My API
 * OpenAPI spec version: 1.0.0
 */

export type PlacementRequestPlacementType = typeof PlacementRequestPlacementType[keyof typeof PlacementRequestPlacementType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlacementRequestPlacementType = {
  Full_Time: 'Full Time',
  Contract: 'Contract',
  Part_Time: 'Part Time',
} as const;
